// extracted by mini-css-extract-plugin
export default {"gridSection":"GridModal_gridSection__Nu2KB"};